import { InsightListItem, InsightVariant } from './InsightListItem';
import {
  InsightType,
  UnifiedInsightItem,
} from '@/UI/Insights/UnifiedAiInsights/hooks/useUnifiedInsights.hook';

interface DayGroupProps {
  label: string;
  items: UnifiedInsightItem[];
  insightType: InsightType;
  onTopicClick?: (topic: string) => void;
}

const variantFor = (item: UnifiedInsightItem, insightType: InsightType): InsightVariant => {
  if (insightType === 'alerts') return 'alert';
  if (insightType === 'flagged') return 'flagged';
  if (insightType === 'market_insights') return 'market_insights';
  // "all" tab: backend emits one row per signal. alert_name is the discriminator
  // for the alert variant; otherwise flag wins over market_insight as the more
  // urgent signal.
  if (item.alert_name !== null) return 'alert';
  return item.is_flagged ? 'flagged' : 'market_insights';
};

const rowKey = (item: UnifiedInsightItem): string =>
  item.alert_match_id !== null ? `alert:${item.alert_match_id}` : item.conversation_conv_id;

export const DayGroup = ({ label, items, insightType, onTopicClick }: DayGroupProps) => (
  <div className="flex gap-3">
    <div className="flex flex-col items-center">
      <div className="w-2.5 h-2.5 rounded-full bg-foreground-subtle shrink-0 mt-2" />
      <div className="w-px flex-1 bg-border mt-1" />
    </div>
    <div className="flex-1 min-w-0 pb-2">
      <p className="text-sm font-medium text-foreground-subtle py-0.5 mb-2">{label}</p>
      <div className="space-y-2.5">
        {items.map((item) => (
          <InsightListItem
            key={rowKey(item)}
            item={item}
            variant={variantFor(item, insightType)}
            onTopicClick={onTopicClick}
          />
        ))}
      </div>
    </div>
  </div>
);
